import { MusicCard, SerenityCard, WisdomCard } from '@components/Cards';
import { memo } from 'react';
import { FavoriteAlbumData } from '../../types';

interface FavoriteAlbumCardProps {
  album: FavoriteAlbumData;
  onPlay: (album: FavoriteAlbumData) => void;
  onUnfavorite: (id: string) => void;
}

export const FavoriteAlbumCard = memo(
  ({ album, onPlay, onUnfavorite }: FavoriteAlbumCardProps) => {
    const category =
      album.category && album.category.trim() !== '' ? album.category : 'music';
    const contributor = album.contributors?.[0];
    const isBook = category === 'book';

    return (
      <div className="flex flex-col w-full">
        {/* MUSIC CARD DESIGN */}
        {category === 'music' && (
          <MusicCard
            album={album}
            contributor={contributor}
            videoUrl={album.videoMobileUrl || contributor?.videoMobileUrl}
            posterUrl={
              album.videoMobilePreviewUrl ||
              contributor?.videoMobilePreviewUrl ||
              contributor?.thumbnailUrl
            }
            albumArtUrl={album.albumArtUrl}
            albumName={album.albumName || album.name}
            likes={album.likes || 0}
            isLiked={true}
            onClick={() => onPlay(album)}
            onFavoriteClick={(e) => {
              e.stopPropagation();
              onUnfavorite(album.id);
            }}
            showPlayButton={false}
            showFavoriteButton={false}
            showLikesCount={true}
          />
        )}

        {/* SERENITY CARD DESIGN */}
        {category === 'serenity' && (
          <SerenityCard
            album={album}
            contributor={contributor}
            videoUrl={album.videoMobileUrl || contributor?.videoMobileUrl}
            posterUrl={
              album.videoMobilePreviewUrl ||
              contributor?.videoMobilePreviewUrl ||
              contributor?.thumbnailUrl
            }
            albumName={album.albumName || album.name}
            likes={album.likes || 0}
            isLiked={true}
            onClick={() => onPlay(album)}
            onFavoriteClick={(e) => {
              e.stopPropagation();
              onUnfavorite(album.id);
            }}
            showLikesCount={true}
          />
        )}

        {/* BOOK/AUDIOBOOK CARD DESIGN */}
        {isBook && (
          <WisdomCard
            album={album}
            contributor={contributor}
            albumArtUrl={album.albumArtUrl}
            albumName={album.albumName || album.name}
            likes={album.likes || 0}
            isLiked={true}
            onClick={() => onPlay(album)}
            onFavoriteClick={(e) => {
              e.stopPropagation();
              onUnfavorite(album.id);
            }}
            showLikesCount={true}
          />
        )}
      </div>
    );
  },
);

FavoriteAlbumCard.displayName = 'FavoriteAlbumCard';
